import * as React from "react";
import Box from "@mui/material/Box";
// import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Route, Routes, NavLink, useLocation } from "react-router-dom";
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PaymentsIcon from '@mui/icons-material/Payments';
import Diversity2RoundedIcon from '@mui/icons-material/Diversity2Rounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AirplayOutlinedIcon from '@mui/icons-material/AirplayOutlined';
// import { Icon } from '@iconify/react';
import billcube_logo from '../images/billCubeLogo2.jpeg'
// import SalesHome from "../pages/sales/SalesHome";
// import Zoom from '@mui/material/Zoom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Profile from "./navTab/Profile";
import { Badge, Button, IconButton, Tooltip } from "@mui/material";
import NotificationBar from "./navTab/NotificationBar";
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PixIcon from '@mui/icons-material/Pix';
import AssessmentIcon from '@mui/icons-material/Assessment';
import styles from './../styles.module.css';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import { getMenuSettingList, getNotifications } from "../actions/actions";
import { useDispatch, useSelector } from "react-redux";

// ------------App bar Search style start--------------
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '20%',
    height: 28,
    // [theme.breakpoints.up('sm')]: {
    //     marginLeft: theme.spacing(1),
    //     width: 'auto',
    // },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    // color: 'inherit',
    color: '#ffffff',
    height: 28,
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        fontSize: '12px',
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',


        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

//   -----------App Search Style End-------------


const drawerWidth = 60;

export default function FixDrawer() {
    const dispatch = useDispatch();
    // const classes = useStyles();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const location = useLocation();
    const [passwordVisibility, setPasswordVisibility] = React.useState(false);
   
    // ----------------------------

    const handlePasswordVisibility = () => {
        passwordVisibility === true ?
            setPasswordVisibility(false)
            :
            setPasswordVisibility(true)
    };

    var containsSales = location.pathname.includes('/sales/');
    var containsPurchase = location.pathname.includes('/purchase/');
    var containsReports = location.pathname.includes('/reports');
    var containsMasters = location.pathname.includes('/masters');
    var containsProduction = location.pathname.includes('/production');

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <>
            {/* {passwordVisibility === true &&
                <Box id={menuId} className={`${styles.menu_list}`}>
                    <NavLink to="/dashboard" className={`${styles.top_menu}`}

                    >
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <AirplayOutlinedIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                  
                    <NavLink to="/purchase" className={`${styles.top_menu}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <ShoppingCartIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Purchase" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
               
                    <NavLink to="/sales" className={`${styles.top_menu}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <PaymentsIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Sales" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    <NavLink to="/masters" className={`${styles.top_menu}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <ShoppingCartRoundedIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Payments" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    <NavLink to="/masters" className={`${styles.top_menu}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <ShoppingCartRoundedIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Reports" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                  
                    <NavLink to="/masters" className={`${styles.top_menu}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <ShoppingCartRoundedIcon sx={{ fontSize: '18px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Masters" primaryTypographyProps={{ fontSize: '12px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>

                </Box>
            } */}
        </>
    );
    const menuSettingList = useSelector(state => state.menuSetting.menuSetting)
    const notifications = useSelector(state => state.notifications.notifications)

    const fetchData = () => {
        dispatch(getMenuSettingList({ companyId: userInfo.companyId }))
        dispatch(getNotifications({ companyId: userInfo.companyId }))
    };

    React.useEffect(() => {
        fetchData()
    }, []);

    React.useEffect(() => {
    }, [menuSettingList, notifications])

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <>
            {passwordVisibility === false &&
                <Box id={mobileMenuId} className={`${styles.menu_list}`}>
                    <NavLink to="/dashboard"
                        className={`${styles.top_menu} ${location.pathname == '/dashboard' ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`} >
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <AirplayOutlinedIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                                
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>

                    <NavLink to="/purchase/"
                        className={`${styles.top_menu} ${containsPurchase === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <ShoppingCartIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Purchase" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    <NavLink to="/sales/"
                        className={`${styles.top_menu} ${containsSales === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <PaymentsIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Sales" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    {/* <NavLink to="/payments/"
                        className={`${styles.top_menu} ${containsPayments === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <PaymentsIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Payments" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink> */}
                    {/* <NavLink to="/payments"
                        className={`${styles.top_menu} ${location.pathname == '/payments' ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <PixIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Payments" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink> */}
                    <NavLink to="/reports"
                        className={`${styles.top_menu} ${containsReports === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <AssessmentIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Reports" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    <NavLink to="/masters"
                        className={`${styles.top_menu} ${containsMasters === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <SensorOccupiedIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Masters" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    {/* {menuSettingList.productionRequired === 'true' && */}
                 {menuSettingList.length > 0 && menuSettingList[0].productionRequired === 'true' &&
                    <NavLink to="/production"
                        className={`${styles.top_menu} ${containsProduction === true ? styles.button_k : ''}`}>
                        <ListItemButton className={`${styles.appbar_tab}`}>
                            <ListItemIcon className={`${styles.appbar_tab_icon}`}>
                                <SensorOccupiedIcon sx={{ fontSize: '22px', color: '#ffffff' }} />
                            </ListItemIcon>
                            <ListItemText primary="Production" primaryTypographyProps={{ fontSize: '13px', fontFamily: "'Roboto','Helvetica','Arial','sans-serif'", textAlign: 'center', color: '#ffffff' }} />
                        </ListItemButton>
                    </NavLink>
                    }
                </Box>
            }
        </>
    );

    // -----------------
    return (
        <Box sx={{ display: "flex", paddingBottom: '20px' }}>
            <CssBaseline />

            <AppBar
                position="fixed"
                sx={{ ml: `${drawerWidth}px`, "background-image": "linear-gradient(to right, #00527c,#1a6082, #278fc2)", boxShadow:'none' }}>
                <Toolbar sx={{ color: 'black' }}>
                    <img src={billcube_logo} style={{ marginLeft: '4px', height: "25px", width: "" }} />
                    {/* Bill billCube */}
                    <Box sx={{ flexGrow: 0.1 }} />
                    {/* {renderMenu} */}
                    {renderMobileMenu}
                    <Box sx={{ flexGrow: 1 }} />
                    {/* <IconButton
                        aria-label="Toggle password visibility"
                        onClick={handlePasswordVisibility}>
                        {passwordVisibility ? <VisibilityOff /> : <Visibility />}
                    </IconButton> */}
                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon sx={{ color: '#ffffff' }} />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }} />
                    </Search>

                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                        >
                            {/* <Badge badgeContent={17} color="error">
                                <NotificationsIcon />
                            </Badge> */}
                            <NotificationBar />
                        </IconButton>
                        <IconButton
                            size="large"
                            edge="end"
                            aria-label="account of current user"
                            aria-haspopup="true"
                            color="inherit">
                            <Profile />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box
                component="main"
                sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
            >

            </Box>
        </Box>
    );
}